"use client";

import { c as _c } from "react/compiler-runtime";
import { ThemeProvider, ToastProvider, UIProvider } from "@xefi/x-react/providers";
import { PropsWithChildren } from "react";
import ImportTracker from "@/components/payments/common/ImportTracker";
import { QueryProvider } from "./QueryProvider";
interface ProvidersProps extends PropsWithChildren {
  locale?: string;
}
export function Providers(t0) {
  const $ = _c(7);
  const {
    children,
    locale: t1
  } = t0;
  const locale = t1 === undefined ? "fr" : t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ToastProvider />;
    t3 = <ImportTracker />;
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  let t4;
  if ($[2] !== children) {
    t4 = <ThemeProvider disableTransitionOnChange={true}>{t2}{t3}{children}</ThemeProvider>;
    $[2] = children;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== locale || $[5] !== t4) {
    t5 = <QueryProvider><UIProvider locale={locale}>{t4}</UIProvider></QueryProvider>;
    $[4] = locale;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}